import React from 'react';
import { useTranslation } from 'react-i18next';
import CartInformation from '../../common/CartInformation';
import { useCartData } from '../../../hooks/order';

// CartInformation.js owns the real charge-breakdown math (useCartData) and, critically, the
// order-submission effect that TermsAndConditions' "Place Order" button triggers via
// submitOrderRef - reusing it here (desktop sidebar or mobile inline, never both at once)
// avoids a second, divergent submit path. Do not also build a separate mobile cart bar.
// The "Cart" heading itself doesn't exist in CartInformation.js or anywhere else in the
// repo (its first section is "Appointment Date") - added here, SPC-only, rather than
// touching the shared component.
const CartSummary = ({ setActiveKey, submitOrderRef }) => {
  const { t } = useTranslation();
  const { isScheduleSuppressed } = useCartData();
  return (
    <>
      <div className="spc-cart">
        <h3 className="spc-cart__header">{t('singlePageCheckout.cartHeader')}</h3>
        <CartInformation setActiveKey={setActiveKey} submitOrderRef={submitOrderRef} isSpc />
      </div>
      {/* Sits below the card rather than inside it (CartInformation skips its own copy when isSpc). */}
      <p className="spc-cart-taxes-note">
        {isScheduleSuppressed ? t('cart.taxesNoteActivated') : t('cart.taxesNoteInstalled')}
      </p>
    </>
  );
};

export default CartSummary;
